
export default {
    tooltip: {
        trigger: 'axis',
    },
    legend: {
        data: [],
        bottom: 0
    },
    xAxis: [
        {
            type: 'category',
            boundaryGap: true,
            data: []
        }
    ],
    yAxis: [
        {
            type: 'value',
            scale: true,
            boundaryGap: [0.2, 0.2]
        }
    ],
    series: [
        {
            name: '',
            type: 'line',
            data: [],
            showSymbol: false,
        },
        {
            name: '',
            type: 'line',
            data: [],
            showSymbol: false,
        }
    ]
};
